import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '',
    templateUrl: './user.component.svg',
    styleUrls: ['./user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserComponent {}
